// 논리적으로 나누려면..
// 이벤트에 의해서 발생하는 parameter = context
// 설정에 의해서 발생하는 parameter = setting

// BroadcastSetting
// Context1 : modelIndex,
// backgroundFileName, isReverseModel = broadcastBox#initModelFacadeSetting()
// Context2 : outerFacadeVisibility = broadcastBox#initOuterVisibility()
// Context2: (VirtupetProfile)
// Context3 : (chat + donation)

const TEXT_SCHEMA = {
  text: "",
  style: "",
  context: "",
};

const DEFAULT_OUTER_FACADE_VISIBILITY = {
  // DB 저장
  "virtupet-name-tag": false,
  "exp-bar-layer": true,
  "sync-status": false,
  "connection-status": "error", // sub 상태바 3모드: "always"(항상) | "error"(에러시에만·기본) | "off"(꺼짐). BroadcastBox가 statusMode로 해석

  // DB 안저장
  "streamer-status-text-layer": false,
  "streamer-message": false,
};

const FULL_CONTEXT_SCHEMA = {
  streamerAliasId: "",
  virtupetProfile: {
    name: "",
  },
  chat: {},
  donation: {
    profile: {
      nickname: null,
    },
    extras: {
      payAmount: 10000,
    },
  },
};

// initSetting은 파일명이나, 상태
// visibility = layer

const FULL_SETTING_SCHEMA = {
  // modelIndex
  modelIndex: "fox_v5",

  // SETTING (modelFacade + outerFacade)
  // initModelFacadeSetting
  backgroundFilename: null,
  isReverseModel: false,

  // visibility (layer control)
  // outerFacadeVisibility. same as OUTER_FACADE_VISIBILITY
  // layer control은 `-` element naming syntax를 따른다
  // DB 저장
  ...DEFAULT_OUTER_FACADE_VISIBILITY,
};

// connection-status 저장값 정규화 — 레거시 boolean(true=항상/false=꺼짐)과 신규 3모드 문자열 모두 수용
export function resolveConnStatusMode(v) {
  if (v === "always" || v === true) return "always";
  if (v === "off" || v === false) return "off";
  return "error"; // "error" | 미설정 → 기본값(에러시에만)
}

export { FULL_CONTEXT_SCHEMA, FULL_SETTING_SCHEMA, DEFAULT_OUTER_FACADE_VISIBILITY };
export default { FULL_CONTEXT_SCHEMA, FULL_SETTING_SCHEMA, DEFAULT_OUTER_FACADE_VISIBILITY };
